import { translation } from 'I18n/i18n'
import AnchorPart from 'components/anchorPart/anchorPart'
import ScrollContainer from 'components/scrollContainer/scrollContainer'
import ScrollSection from 'components/scrollSection/scrollSection'
import ScrollSectionWitthChildren from 'components/scrollSection/scrollSectionWithChildren'
import AnchorButtonContext from 'contexts/anchorButton'
import CounterContext from 'contexts/counter'
import HeadbandContext from 'contexts/headband'
import englishCondition from 'pages/visiteur/englishAssert'
import { useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import PresentationBloc0 from './presentation/presentationBloc0'

interface IProps {
   visiteur?:boolean
}

export default function SiteNeubourg(props: IProps) {
   const lang = useSelector((state: any) => state.languageReducer.language)
   const [altLanguage, setAltLanguage] = useState<boolean>(englishCondition(lang, props.visiteur))
   const { setCounter, counterDefault } = useContext(CounterContext)
   const { setHeadband } = useContext(HeadbandContext)
   const {setAnchorButton} = useContext(AnchorButtonContext)
   useEffect(() => {
      setCounter(counterDefault)
      setHeadband(translation(lang, 'siteNeubourg', 'title'))
      setAnchorButton(translation(lang, 'siteNeubourg', 'anchorBtns'))
   }, [])
   return (
      <ScrollContainer>
         <AnchorPart anchor={{"partName": translation(lang, 'siteNeubourg', 'anchorBtns')[0], id: 0}} />
         <ScrollSection zoneName={altLanguage ? "Plant introduction" : "Présentation site"}  topInsertedElements={[
            <PresentationBloc0 key={0}/>,
            <video 
               key={1} 
               src='/video/Film Aptar Le Neubourg - oct 2023.mp4' 
               autoPlay 
               controls 
               controlsList='nodownload nofullscreen noremoteplayback disablePictureInPicture' 
               loop 
               muted 
               style={{ width: '1055px' }}/>
         ]} /> 
         <AnchorPart anchor={{"partName": translation(lang, 'moulage', 'title'), id: 1}} />
         <ScrollSection zoneName={altLanguage ? "Molding unit" : "Moulage"}  />
         <AnchorPart anchor={{"partName": translation(lang, 'assemblage', 'title'), id: 2}} />
         <ScrollSectionWitthChildren zoneName={altLanguage ? "Assembly unit" : "Assemblage"}  />
         <AnchorPart anchor={{"partName": translation(lang, 'servicesSupport', 'title'), id: 3}} />
         <ScrollSection zoneName={altLanguage ? "Support departments" : "Services support"}  />
      </ScrollContainer>
   )
}
